
import React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';

import ToolbarLinkButtons from "../common/ToolbarLinkButtons"

const classNames = mergeStyleSets({
    root: {
        height: '100%',
        width: '1024px'
    },

    heading: {
        borderBottom: '1px solid #000000'
    },

    btnBox: {
        padding: '1em 0em'
    },

    btn: {
        width: '49%'
    },

    autoFillBtn: {
        paddingBottom: '1em',
    }
});

const CalculationPageView = ({
    onGoBackClick,
    summary,
    toolbarItems,
    usekList
}) => {

    React.useEffect(() => {
        document.getElementById('content').scrollTo(0, 0)
    }, [])

    const handleGoBackClick = () => {
        if (onGoBackClick) {
            onGoBackClick();
        }
    }

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item>
                <h3 className={classNames.heading}>Výpočet nákladů a množství materiálu</h3>
            </Stack.Item>
            <Stack.Item className={classNames.autoFillBtn}>
                <ToolbarLinkButtons
                    items={toolbarItems}
                />
            </Stack.Item>
            <Stack.Item>
                {usekList}
            </Stack.Item>
            <Stack.Item>
                <h3 className={classNames.heading}>Sumarizace</h3>
            </Stack.Item>
            <Stack.Item>
                {summary}
            </Stack.Item>
            <Stack.Item className={classNames.btnBox}>
                <PrimaryButton className={classNames.btn} iconProps={{iconName: 'triangleLeft12'}} onClick={handleGoBackClick}>Zpět na výběr ceníku</PrimaryButton>
            </Stack.Item>
        </Stack>
    )
}

export default CalculationPageView;
